/****************
 * WHICH CONVERSATION A CHAT BOX SHOWS. 2026-10-24.
 *
 * Twin file: frontend/src/lib/chatDock.core.ts and mobile-app/src/lib/chatDock.core.ts
 * must be byte-identical. A conversation is a member (dm, by handle) or a group
 * (by id), as rest/community_chat.go lists them. openChat() is how any screen
 * opens one: the web's dock (components/community/ChatDock.tsx) and the phone's
 * Orb messages listen for it.
 ****************/

export interface ChatRef {
  kind: 'dm' | 'group';
  handle?: string;
  group?: number;
  name: string;
}

export const CHAT_OPEN_EVENT = 'copyfi:chat:open';

export function chatKey(c: Pick<ChatRef, 'kind' | 'handle' | 'group'>): string {
  return c.kind === 'group' ? `g:${c.group}` : `dm:${(c.handle || '').toLowerCase()}`;
}
